/* sucrase/dist/esm/parser/plugins/typescript.js */ function _(require, module, exports, __esModule, __esExport) {
    __esModule();
    exports.tsParseModifiers = tsParseModifiers;
    exports.tsParseModifier = tsParseModifier;
    exports.tsTryParseTypeParameters = tsTryParseTypeParameters;
    exports.tsTryParseTypeAnnotation = tsTryParseTypeAnnotation;
    exports.tsParseTypeAnnotation = tsParseTypeAnnotation;
    exports.tsParseType = tsParseType;
    exports.tsParseNonConditionalType = tsParseNonConditionalType;
    exports.tsParseTypeAssertion = tsParseTypeAssertion;
    exports.tsTryParseJSXTypeArgument = tsTryParseJSXTypeArgument;
    exports.tsParseImportEqualsDeclaration = tsParseImportEqualsDeclaration;
    exports.tsIsDeclarationStart = tsIsDeclarationStart;
    exports.tsParseFunctionBodyAndFinish = tsParseFunctionBodyAndFinish;
    exports.tsParseSubscript = tsParseSubscript;
    exports.tsTryParseExport = tsTryParseExport;
    exports.tsParseImportSpecifier = tsParseImportSpecifier;
    exports.tsParseExportSpecifier = tsParseExportSpecifier;
    exports.tsTryParseExportDefaultExpression = tsTryParseExportDefaultExpression;
    exports.tsTryParseStatementContent = tsTryParseStatementContent;
    exports.tsTryParseClassMemberWithIsStatic = tsTryParseClassMemberWithIsStatic;
    exports.tsParseIdentifierStatement = tsParseIdentifierStatement;
    exports.tsParseExportDeclaration = tsParseExportDeclaration;
    exports.tsAfterParseClassSuper = tsAfterParseClassSuper;
    exports.tsStartParseObjPropValue = tsStartParseObjPropValue;
    exports.tsStartParseFunctionParams = tsStartParseFunctionParams;
    exports.tsAfterParseVarHead = tsAfterParseVarHead;
    exports.tsStartParseAsyncArrowFromCallExpression = tsStartParseAsyncArrowFromCallExpression;
    exports.tsParseMaybeAssign = tsParseMaybeAssign;
    exports.tsParseMaybeAssignWithJSX = tsParseMaybeAssignWithJSX;
    exports.tsParseMaybeAssignWithoutJSX = tsParseMaybeAssignWithoutJSX;
    exports.tsParseArrow = tsParseArrow;
    exports.tsParseAssignableListItemTypes = tsParseAssignableListItemTypes;
    exports.tsParseMaybeDecoratorArguments = tsParseMaybeDecoratorArguments;
    const index_1 = require("bfb18d0576") /* ../tokenizer/index */;
    const keywords_1 = require("99ff836c64") /* ../tokenizer/keywords */;
    const types_1 = require("f0c35cbd76") /* ../tokenizer/types */;
    const base_1 = require("540718e523") /* ../traverser/base */;
    const expression_1 = require("8178e7c3c8") /* ../traverser/expression */;
    const lval_1 = require("4cefc59e67") /* ../traverser/lval */;
    const statement_1 = require("e3b9989da1") /* ../traverser/statement */;
    const util_1 = require("bc94bbadc1") /* ../traverser/util */;
    const jsx_1 = require("d7708a7d24") /* ./jsx */;
    function tsIsIdentifier() {
        // TODO: actually a bit more complex in TypeScript, but shouldn't matter.
        // See https://github.com/Microsoft/TypeScript/issues/15008
        return (0, index_1.match)(types_1.TokenType.name);
    }
    function isLiteralPropertyName() {
        return ((0, index_1.match)(types_1.TokenType.name) ||
            Boolean(base_1.state.type & types_1.TokenType.IS_KEYWORD) ||
            (0, index_1.match)(types_1.TokenType.string) ||
            (0, index_1.match)(types_1.TokenType.num) ||
            (0, index_1.match)(types_1.TokenType.bigint) ||
            (0, index_1.match)(types_1.TokenType.decimal));
    }
    function tsNextTokenCanFollowModifier() {
        // Note: TypeScript's implementation is much more complicated because
        // more things are considered modifiers there.
        // This implementation only handles modifiers not handled by babylon itself. And "static".
        // TODO: Would be nice to avoid lookahead. Want a hasLineBreakUpNext() method...
        const snapshot = base_1.state.snapshot();
        (0, index_1.next)();
        const canFollowModifier = ((0, index_1.match)(types_1.TokenType.bracketL) ||
            (0, index_1.match)(types_1.TokenType.braceL) ||
            (0, index_1.match)(types_1.TokenType.star) ||
            (0, index_1.match)(types_1.TokenType.ellipsis) ||
            (0, index_1.match)(types_1.TokenType.hash) ||
            isLiteralPropertyName()) &&
            !(0, util_1.hasPrecedingLineBreak)();
        if (canFollowModifier) {
            return true;
        }
        else {
            base_1.state.restoreFromSnapshot(snapshot);
            return false;
        }
    }
    function tsParseModifiers(allowedModifiers) {
        while (true) {
            const modifier = tsParseModifier(allowedModifiers);
            if (modifier === null) {
                break;
            }
        }
    }
    /** Parses a modifier matching one the given modifier names. */
    function tsParseModifier(allowedModifiers) {
        if (!(0, index_1.match)(types_1.TokenType.name)) {
            return null;
        }
        const modifier = base_1.state.contextualKeyword;
        if (allowedModifiers.indexOf(modifier) !== -1 && tsNextTokenCanFollowModifier()) {
            switch (modifier) {
                case keywords_1.ContextualKeyword._readonly:
                    base_1.state.tokens[base_1.state.tokens.length - 1].type = types_1.TokenType._readonly;
                    break;
                case keywords_1.ContextualKeyword._abstract:
                    base_1.state.tokens[base_1.state.tokens.length - 1].type = types_1.TokenType._abstract;
                    break;
                case keywords_1.ContextualKeyword._static:
                    base_1.state.tokens[base_1.state.tokens.length - 1].type = types_1.TokenType._static;
                    break;
                case keywords_1.ContextualKeyword._public:
                    base_1.state.tokens[base_1.state.tokens.length - 1].type = types_1.TokenType._public;
                    break;
                case keywords_1.ContextualKeyword._private:
                    base_1.state.tokens[base_1.state.tokens.length - 1].type = types_1.TokenType._private;
                    break;
                case keywords_1.ContextualKeyword._protected:
                    base_1.state.tokens[base_1.state.tokens.length - 1].type = types_1.TokenType._protected;
                    break;
                case keywords_1.ContextualKeyword._override:
                    base_1.state.tokens[base_1.state.tokens.length - 1].type = types_1.TokenType._override;
                    break;
                case keywords_1.ContextualKeyword._declare:
                    base_1.state.tokens[base_1.state.tokens.length - 1].type = types_1.TokenType._declare;
                    break;
                default:
                    break;
            }
            return modifier;
        }
        return null;
    }
    function tsParseEntityName() {
        (0, expression_1.parseIdentifier)();
        while ((0, index_1.eat)(types_1.TokenType.dot)) {
            (0, expression_1.parseIdentifier)();
        }
    }
    function tsParseTypeReference() {
        tsParseEntityName();
        if (!(0, util_1.hasPrecedingLineBreak)() && (0, index_1.match)(types_1.TokenType.lessThan)) {
            tsParseTypeArguments();
        }
    }
    function tsParseThisTypePredicate() {
        (0, index_1.next)();
        tsParseTypeAnnotation();
    }
    function tsParseThisTypeNode() {
        (0, index_1.next)();
    }
    function tsParseTypeQuery() {
        (0, util_1.expect)(types_1.TokenType._typeof);
        if ((0, index_1.match)(types_1.TokenType._import)) {
            tsParseImportType();
        }
        else {
            tsParseEntityName();
        }
        if (!(0, util_1.hasPrecedingLineBreak)() && (0, index_1.match)(types_1.TokenType.lessThan)) {
            tsParseTypeArguments();
        }
    }
    function tsParseImportType() {
        (0, util_1.expect)(types_1.TokenType._import);
        (0, util_1.expect)(types_1.TokenType.parenL);
        (0, util_1.expect)(types_1.TokenType.string);
        (0, util_1.expect)(types_1.TokenType.parenR);
        if ((0, index_1.eat)(types_1.TokenType.dot)) {
            tsParseEntityName();
        }
        if ((0, index_1.match)(types_1.TokenType.lessThan)) {
            tsParseTypeArguments();
        }
    }
    function tsParseTypeParameter() {
        (0, index_1.eat)(types_1.TokenType._const);
        const hadIn = (0, index_1.eat)(types_1.TokenType._in);
        const hadOut = (0, util_1.eatContextual)(keywords_1.ContextualKeyword._out);
        (0, index_1.eat)(types_1.TokenType._const);
        if ((hadIn || hadOut) && !(0, index_1.match)(types_1.TokenType.name)) {
            // The "in" or "out" keyword must have actually been the type parameter
            // name, so set it as the name.
            base_1.state.tokens[base_1.state.tokens.length - 1].type = types_1.TokenType.name;
        }
        else {
            (0, expression_1.parseIdentifier)();
        }
        if ((0, index_1.eat)(types_1.TokenType._extends)) {
            tsParseType();
        }
        if ((0, index_1.eat)(types_1.TokenType.eq)) {
            tsParseType();
        }
    }
    function tsTryParseTypeParameters() {
        if ((0, index_1.match)(types_1.TokenType.lessThan)) {
            tsParseTypeParameters();
        }
    }
    function tsParseTypeParameters() {
        const oldIsType = (0, index_1.pushTypeContext)(0);
        if ((0, index_1.match)(types_1.TokenType.lessThan) || (0, index_1.match)(types_1.TokenType.typeParameterStart)) {
            (0, index_1.next)();
        }
        else {
            (0, util_1.unexpected)();
        }
        while (!(0, index_1.eat)(types_1.TokenType.greaterThan) && !base_1.state.error) {
            tsParseTypeParameter();
            (0, index_1.eat)(types_1.TokenType.comma);
        }
        (0, index_1.popTypeContext)(oldIsType);
    }
    // Note: In TypeScript implementation we must provide `yieldContext` and `awaitContext`,
    // but here it's always false, because this is only used for types.
    function tsFillSignature(returnToken) {
        // Arrow fns *must* have return token (`=>`). Normal functions can omit it.
        const returnTokenRequired = returnToken === types_1.TokenType.arrow;
        tsTryParseTypeParameters();
        (0, util_1.expect)(types_1.TokenType.parenL);
        // Create a scope even though we're doing type parsing so we don't accidentally
        // treat params as top-level bindings.
        base_1.state.scopeDepth++;
        tsParseBindingListForSignature(false /* isBlockScope */);
        base_1.state.scopeDepth--;
        if (returnTokenRequired) {
            tsParseTypeOrTypePredicateAnnotation(returnToken);
        }
        else if ((0, index_1.match)(returnToken)) {
            tsParseTypeOrTypePredicateAnnotation(returnToken);
        }
    }
    function tsParseBindingListForSignature(isBlockScope) {
        (0, lval_1.parseBindingList)(types_1.TokenType.parenR, isBlockScope);
    }
    function tsParseTypeMemberSemicolon() {
        if (!(0, index_1.eat)(types_1.TokenType.comma)) {
            (0, util_1.semicolon)();
        }
    }
    function tsParseSignatureMember() {
        tsFillSignature(types_1.TokenType.colon);
        tsParseTypeMemberSemicolon();
    }
    function tsIsUnambiguouslyIndexSignature() {
        const snapshot = base_1.state.snapshot();
        (0, index_1.next)(); // Skip '{'
        const isIndexSignature = (0, index_1.eat)(types_1.TokenType.name) && (0, index_1.match)(types_1.TokenType.colon);
        base_1.state.restoreFromSnapshot(snapshot);
        return isIndexSignature;
    }
    function tsTryParseIndexSignature() {
        if (!((0, index_1.match)(types_1.TokenType.bracketL) && tsIsUnambiguouslyIndexSignature())) {
            return false;
        }
        const oldIsType = (0, index_1.pushTypeContext)(0);
        (0, util_1.expect)(types_1.TokenType.bracketL);
        (0, expression_1.parseIdentifier)();
        tsParseTypeAnnotation();
        (0, util_1.expect)(types_1.TokenType.bracketR);
        tsTryParseTypeAnnotation();
        tsParseTypeMemberSemicolon();
        (0, index_1.popTypeContext)(oldIsType);
        return true;
    }
    function tsParsePropertyOrMethodSignature(isReadonly) {
        (0, index_1.eat)(types_1.TokenType.question);
        if (!isReadonly && ((0, index_1.match)(types_1.TokenType.parenL) || (0, index_1.match)(types_1.TokenType.lessThan))) {
            tsFillSignature(types_1.TokenType.colon);
            tsParseTypeMemberSemicolon();
        }
        else {
            tsTryParseTypeAnnotation();
            tsParseTypeMemberSemicolon();
        }
    }
    function tsParseTypeMember() {
        if ((0, index_1.match)(types_1.TokenType.parenL) || (0, index_1.match)(types_1.TokenType.lessThan)) {
            // call signature
            tsParseSignatureMember();
            return;
        }
        if ((0, index_1.match)(types_1.TokenType._new)) {
            (0, index_1.next)();
            if ((0, index_1.match)(types_1.TokenType.parenL) || (0, index_1.match)(types_1.TokenType.lessThan)) {
                // constructor signature
                tsParseSignatureMember();
            }
            else {
                tsParsePropertyOrMethodSignature(false);
            }
            return;
        }
        const readonly = !!tsParseModifier([keywords_1.ContextualKeyword._readonly]);
        const found = tsTryParseIndexSignature();
        if (found) {
            return;
        }
        if (((0, util_1.isContextual)(keywords_1.ContextualKeyword._get) || (0, util_1.isContextual)(keywords_1.ContextualKeyword._set)) &&
            tsNextTokenCanFollowModifier()) {
            // This is a getter/setter on a type. The tsNextTokenCanFollowModifier
            // function already called next() for us, so continue parsing the name.
        }
        (0, expression_1.parsePropertyName)(-1 /* Types don't need context IDs. */);
        tsParsePropertyOrMethodSignature(readonly);
    }
    function tsParseTypeLiteral() {
        tsParseObjectTypeMembers();
    }
    function tsParseObjectTypeMembers() {
        (0, util_1.expect)(types_1.TokenType.braceL);
        while (!(0, index_1.eat)(types_1.TokenType.braceR) && !base_1.state.error) {
            tsParseTypeMember();
        }
    }
    function tsLookaheadIsStartOfMappedType() {
        const snapshot = base_1.state.snapshot();
        const isStartOfMappedType = tsIsStartOfMappedType();
        base_1.state.restoreFromSnapshot(snapshot);
        return isStartOfMappedType;
    }
    function tsIsStartOfMappedType() {
        (0, index_1.next)();
        if ((0, index_1.eat)(types_1.TokenType.plus) || (0, index_1.eat)(types_1.TokenType.minus)) {
            return (0, util_1.isContextual)(keywords_1.ContextualKeyword._readonly);
        }
        if ((0, util_1.isContextual)(keywords_1.ContextualKeyword._readonly)) {
            (0, index_1.next)();
        }
        if (!(0, index_1.match)(types_1.TokenType.bracketL)) {
            return false;
        }
        (0, index_1.next)();
        if (!tsIsIdentifier()) {
            return false;
        }
        (0, index_1.next)();
        return (0, index_1.match)(types_1.TokenType._in);
    }
    function tsParseMappedTypeParameter() {
        (0, expression_1.parseIdentifier)();
        (0, util_1.expect)(types_1.TokenType._in);
        tsParseType();
    }
    function tsParseMappedType() {
        (0, util_1.expect)(types_1.TokenType.braceL);
        if ((0, index_1.match)(types_1.TokenType.plus) || (0, index_1.match)(types_1.TokenType.minus)) {
            (0, index_1.next)();
            (0, util_1.expectContextual)(keywords_1.ContextualKeyword._readonly);
        }
        else {
            (0, util_1.eatContextual)(keywords_1.ContextualKeyword._readonly);
        }
        (0, util_1.expect)(types_1.TokenType.bracketL);
        tsParseMappedTypeParameter();
        if ((0, util_1.eatContextual)(keywords_1.ContextualKeyword._as)) {
            tsParseType();
        }
        (0, util_1.expect)(types_1.TokenType.bracketR);
        if ((0, index_1.match)(types_1.TokenType.plus) || (0, index_1.match)(types_1.TokenType.minus)) {
            (0, index_1.next)();
            (0, util_1.expect)(types_1.TokenType.question);
        }
        else {
            (0, index_1.eat)(types_1.TokenType.question);
        }
        tsTryParseType();
        (0, util_1.semicolon)();
        (0, util_1.expect)(types_1.TokenType.braceR);
    }
    function tsParseTupleType() {
        (0, util_1.expect)(types_1.TokenType.bracketL);
        while (!(0, index_1.eat)(types_1.TokenType.bracketR) && !base_1.state.error) {
            // Do not validate presence of either none or only labeled elements
            tsParseTupleElementType();
            (0, index_1.eat)(types_1.TokenType.comma);
        }
    }
    function tsParseTupleElementType() {
        // parses `...TsType[]`
        if ((0, index_1.eat)(types_1.TokenType.ellipsis)) {
            tsParseType();
        }
        else {
            // parses `TsType?`
            tsParseType();
            (0, index_1.eat)(types_1.TokenType.question);
        }
        // The type we parsed above was actually a label
        if ((0, index_1.eat)(types_1.TokenType.colon)) {
            // Labeled tuple types must affix the label with `...` or `?`, so no need to handle those here
            tsParseType();
        }
    }
    function tsParseParenthesizedType() {
        (0, util_1.expect)(types_1.TokenType.parenL);
        tsParseType();
        (0, util_1.expect)(types_1.TokenType.parenR);
    }
    function tsParseTemplateLiteralType() {
        // Finish `, read quasi
        (0, index_1.nextTemplateToken)();
        // Finish quasi, read ${
        (0, index_1.nextTemplateToken)();
        while (!(0, index_1.match)(types_1.TokenType.backQuote) && !base_1.state.error) {
            (0, util_1.expect)(types_1.TokenType.dollarBraceL);
            tsParseType();
            // Finish }, read quasi
            (0, index_1.nextTemplateToken)();
            // Finish quasi, read either ${ or `
            (0, index_1.nextTemplateToken)();
        }
        (0, index_1.next)();
    }
    var FunctionType;
    (function (FunctionType) {
        const TSFunctionType = 0;
        FunctionType[FunctionType["TSFunctionType"] = TSFunctionType] = "TSFunctionType";
        const TSConstructorType = TSFunctionType + 1;
        FunctionType[FunctionType["TSConstructorType"] = TSConstructorType] = "TSConstructorType";
        const TSAbstractConstructorType = TSConstructorType + 1;
        FunctionType[FunctionType["TSAbstractConstructorType"] = TSAbstractConstructorType] = "TSAbstractConstructorType";
    })(FunctionType || (FunctionType = {}));
    function tsParseFunctionOrConstructorType(type) {
        if (type === FunctionType.TSAbstractConstructorType) {
            (0, util_1.expectContextual)(keywords_1.ContextualKeyword._abstract);
        }
        if (type === FunctionType.TSConstructorType || type === FunctionType.TSAbstractConstructorType) {
            (0, util_1.expect)(types_1.TokenType._new);
        }
        const oldInDisallowConditionalTypesContext = base_1.state.inDisallowConditionalTypesContext;
        base_1.state.inDisallowConditionalTypesContext = false;
        tsFillSignature(types_1.TokenType.arrow);
        base_1.state.inDisallowConditionalTypesContext = oldInDisallowConditionalTypesContext;
    }
    function tsParseNonArrayType() {
        switch (base_1.state.type) {
            case types_1.TokenType.name:
                tsParseTypeReference();
                return;
            case types_1.TokenType._void:
            case types_1.TokenType._null:
                (0, index_1.next)();
                return;
            case types_1.TokenType.string:
            case types_1.TokenType.num:
            case types_1.TokenType.bigint:
            case types_1.TokenType.decimal:
            case types_1.TokenType._true:
            case types_1.TokenType._false:
                (0, expression_1.parseLiteral)();
                return;
            case types_1.TokenType.minus:
                (0, index_1.next)();
                (0, expression_1.parseLiteral)();
                return;
            case types_1.TokenType._this: {
                tsParseThisTypeNode();
                if ((0, util_1.isContextual)(keywords_1.ContextualKeyword._is) && !(0, util_1.hasPrecedingLineBreak)()) {
                    tsParseThisTypePredicate();
                }
                return;
            }
            case types_1.TokenType._typeof:
                tsParseTypeQuery();
                return;
            case types_1.TokenType._import:
                tsParseImportType();
                return;
            case types_1.TokenType.braceL:
                if (tsLookaheadIsStartOfMappedType()) {
                    tsParseMappedType();
                }
                else {
                    tsParseTypeLiteral();
                }
                return;
            case types_1.TokenType.bracketL:
                tsParseTupleType();
                return;
            case types_1.TokenType.parenL:
                tsParseParenthesizedType();
                return;
            case types_1.TokenType.backQuote:
                tsParseTemplateLiteralType();
                return;
            default:
                if (base_1.state.type & types_1.TokenType.IS_KEYWORD) {
                    (0, index_1.next)();
                    base_1.state.tokens[base_1.state.tokens.length - 1].type = types_1.TokenType.name;
                    return;
                }
                break;
        }
        (0, util_1.unexpected)();
    }
    function tsParseArrayTypeOrHigher() {
        tsParseNonArrayType();
        while (!(0, util_1.hasPrecedingLineBreak)() && (0, index_1.eat)(types_1.TokenType.bracketL)) {
            if (!(0, index_1.eat)(types_1.TokenType.bracketR)) {
                // If we hit ] immediately, this is an array type, otherwise it's an indexed access type.
                tsParseType();
                (0, util_1.expect)(types_1.TokenType.bracketR);
            }
        }
    }
    function tsParseInferType() {
        (0, util_1.expectContextual)(keywords_1.ContextualKeyword._infer);
        (0, expression_1.parseIdentifier)();
        if ((0, index_1.match)(types_1.TokenType._extends)) {
            // Infer type constraints introduce an ambiguity about whether the "extends"
            // is a constraint for this infer type or is another conditional type.
            const snapshot = base_1.state.snapshot();
            (0, util_1.expect)(types_1.TokenType._extends);
            const oldInDisallowConditionalTypesContext = base_1.state.inDisallowConditionalTypesContext;
            base_1.state.inDisallowConditionalTypesContext = true;
            tsParseType();
            base_1.state.inDisallowConditionalTypesContext = oldInDisallowConditionalTypesContext;
            if (base_1.state.error || (!base_1.state.inDisallowConditionalTypesContext && (0, index_1.match)(types_1.TokenType.question))) {
                base_1.state.restoreFromSnapshot(snapshot);
            }
        }
    }
    function tsParseTypeOperatorOrHigher() {
        if ((0, util_1.isContextual)(keywords_1.ContextualKeyword._keyof) ||
            (0, util_1.isContextual)(keywords_1.ContextualKeyword._unique) ||
            (0, util_1.isContextual)(keywords_1.ContextualKeyword._readonly)) {
            (0, index_1.next)();
            tsParseTypeOperatorOrHigher();
        }
        else if ((0, util_1.isContextual)(keywords_1.ContextualKeyword._infer)) {
            tsParseInferType();
        }
        else {
            const oldInDisallowConditionalTypesContext = base_1.state.inDisallowConditionalTypesContext;
            base_1.state.inDisallowConditionalTypesContext = false;
            tsParseArrayTypeOrHigher();
            base_1.state.inDisallowConditionalTypesContext = oldInDisallowConditionalTypesContext;
        }
    }
    function tsParseIntersectionTypeOrHigher() {
        (0, index_1.eat)(types_1.TokenType.bitwiseAND);
        tsParseTypeOperatorOrHigher();
        if ((0, index_1.match)(types_1.TokenType.bitwiseAND)) {
            while ((0, index_1.eat)(types_1.TokenType.bitwiseAND)) {
                tsParseTypeOperatorOrHigher();
            }
        }
    }
    function tsParseUnionTypeOrHigher() {
        (0, index_1.eat)(types_1.TokenType.bitwiseOR);
        tsParseIntersectionTypeOrHigher();
        if ((0, index_1.match)(types_1.TokenType.bitwiseOR)) {
            while ((0, index_1.eat)(types_1.TokenType.bitwiseOR)) {
                tsParseIntersectionTypeOrHigher();
            }
        }
    }
    function tsIsStartOfFunctionType() {
        if ((0, index_1.match)(types_1.TokenType.lessThan)) {
            return true;
        }
        return (0, index_1.match)(types_1.TokenType.parenL) && tsLookaheadIsUnambiguouslyStartOfFunctionType();
    }
    function tsSkipParameterStart() {
        if ((0, index_1.match)(types_1.TokenType.name) || (0, index_1.match)(types_1.TokenType._this)) {
            (0, index_1.next)();
            return true;
        }
        // If this is a possible array/object destructure, walk to the matching bracket/brace.
        // The next token after will tell us definitively whether this is a function param.
        if ((0, index_1.match)(types_1.TokenType.braceL) || (0, index_1.match)(types_1.TokenType.bracketL)) {
            let depth = 1;
            (0, index_1.next)();
            while (depth > 0 && !base_1.state.error) {
                if ((0, index_1.match)(types_1.TokenType.braceL) || (0, index_1.match)(types_1.TokenType.bracketL)) {
                    depth++;
                }
                else if ((0, index_1.match)(types_1.TokenType.braceR) || (0, index_1.match)(types_1.TokenType.bracketR)) {
                    depth--;
                }
                (0, index_1.next)();
            }
            return true;
        }
        return false;
    }
    function tsLookaheadIsUnambiguouslyStartOfFunctionType() {
        const snapshot = base_1.state.snapshot();
        const isUnambiguouslyStartOfFunctionType = tsIsUnambiguouslyStartOfFunctionType();
        base_1.state.restoreFromSnapshot(snapshot);
        return isUnambiguouslyStartOfFunctionType;
    }
    function tsIsUnambiguouslyStartOfFunctionType() {
        (0, index_1.next)();
        if ((0, index_1.match)(types_1.TokenType.parenR) || (0, index_1.match)(types_1.TokenType.ellipsis)) {
            // ( )
            // ( ...
            return true;
        }
        if (tsSkipParameterStart()) {
            if ((0, index_1.match)(types_1.TokenType.colon) || (0, index_1.match)(types_1.TokenType.comma) || (0, index_1.match)(types_1.TokenType.question) || (0, index_1.match)(types_1.TokenType.eq)) {
                // ( xxx :
                // ( xxx ,
                // ( xxx ?
                // ( xxx =
                return true;
            }
            if ((0, index_1.match)(types_1.TokenType.parenR)) {
                (0, index_1.next)();
                if ((0, index_1.match)(types_1.TokenType.arrow)) {
                    // ( xxx ) =>
                    return true;
                }
            }
        }
        return false;
    }
    function tsParseTypeOrTypePredicateAnnotation(returnToken) {
        const oldIsType = (0, index_1.pushTypeContext)(0);
        (0, util_1.expect)(returnToken);
        const finishedReturn = tsParseTypePredicateOrAssertsPrefix();
        if (!finishedReturn) {
            tsParseType();
        }
        (0, index_1.popTypeContext)(oldIsType);
    }
    function tsTryParseTypeOrTypePredicateAnnotation() {
        if ((0, index_1.match)(types_1.TokenType.colon)) {
            tsParseTypeOrTypePredicateAnnotation(types_1.TokenType.colon);
        }
    }
    function tsTryParseTypeAnnotation() {
        if ((0, index_1.match)(types_1.TokenType.colon)) {
            tsParseTypeAnnotation();
        }
    }
    function tsTryParseType() {
        if ((0, index_1.eat)(types_1.TokenType.colon)) {
            tsParseType();
        }
    }
    /**
     * Detect a few special return syntax cases: `x is T`, `asserts x`, `asserts x is T`,
     * `asserts this is T`.
     *
     * Returns true if we parsed the return type, false if there's still a type to be parsed.
     */
    function tsParseTypePredicateOrAssertsPrefix() {
        const snapshot = base_1.state.snapshot();
        if ((0, util_1.isContextual)(keywords_1.ContextualKeyword._asserts)) {
            // Normally this is `asserts x is T`, but at this point, it might be `asserts is T` (a user-
            // defined type guard on the `asserts` variable) or just a type called `asserts`.
            (0, index_1.next)();
            if ((0, util_1.eatContextual)(keywords_1.ContextualKeyword._is)) {
                // If we see `asserts is`, then this must be of the form `asserts is T`, since
                // `asserts is is T` isn't valid.
                tsParseType();
                return true;
            }
            else if (tsIsIdentifier() || (0, index_1.match)(types_1.TokenType._this)) {
                (0, index_1.next)();
                if ((0, util_1.eatContextual)(keywords_1.ContextualKeyword._is)) {
                    // If we see `is`, then this is `asserts x is T`. Otherwise, it's `asserts x`.
                    tsParseType();
                }
                return true;
            }
            else {
                // Regular type, so bail out and start type parsing from scratch.
                base_1.state.restoreFromSnapshot(snapshot);
                return false;
            }
        }
        else if (tsIsIdentifier() || (0, index_1.match)(types_1.TokenType._this)) {
            // This is a regular identifier, which may or may not have "is" after it.
            (0, index_1.next)();
            if ((0, util_1.isContextual)(keywords_1.ContextualKeyword._is) && !(0, util_1.hasPrecedingLineBreak)()) {
                (0, index_1.next)();
                tsParseType();
                return true;
            }
            else {
                // Regular type, so bail out and start type parsing from scratch.
                base_1.state.restoreFromSnapshot(snapshot);
                return false;
            }
        }
        return false;
    }
    function tsParseTypeAnnotation() {
        const oldIsType = (0, index_1.pushTypeContext)(0);
        (0, util_1.expect)(types_1.TokenType.colon);
        tsParseType();
        (0, index_1.popTypeContext)(oldIsType);
    }
    function tsParseType() {
        tsParseNonConditionalType();
        if (base_1.state.inDisallowConditionalTypesContext || (0, util_1.hasPrecedingLineBreak)() || !(0, index_1.eat)(types_1.TokenType._extends)) {
            return;
        }
        // extends type
        const oldInDisallowConditionalTypesContext = base_1.state.inDisallowConditionalTypesContext;
        base_1.state.inDisallowConditionalTypesContext = true;
        tsParseNonConditionalType();
        base_1.state.inDisallowConditionalTypesContext = oldInDisallowConditionalTypesContext;
        (0, util_1.expect)(types_1.TokenType.question);
        // true type
        tsParseType();
        (0, util_1.expect)(types_1.TokenType.colon);
        // false type
        tsParseType();
    }
    function isAbstractConstructorSignature() {
        return (0, util_1.isContextual)(keywords_1.ContextualKeyword._abstract) && (0, index_1.lookaheadType)() === types_1.TokenType._new;
    }
    function tsParseNonConditionalType() {
        if (tsIsStartOfFunctionType()) {
            tsParseFunctionOrConstructorType(FunctionType.TSFunctionType);
            return;
        }
        if ((0, index_1.match)(types_1.TokenType._new)) {
            // As in `new () => Date`
            tsParseFunctionOrConstructorType(FunctionType.TSConstructorType);
            return;
        }
        else if (isAbstractConstructorSignature()) {
            // As in `abstract new () => Date`
            tsParseFunctionOrConstructorType(FunctionType.TSAbstractConstructorType);
            return;
        }
        tsParseUnionTypeOrHigher();
    }
    function tsParseTypeAssertion() {
        const oldIsType = (0, index_1.pushTypeContext)(1);
        tsParseType();
        (0, util_1.expect)(types_1.TokenType.greaterThan);
        (0, index_1.popTypeContext)(oldIsType);
        (0, expression_1.parseMaybeUnary)();
    }
    function tsTryParseJSXTypeArgument() {
        if ((0, index_1.eat)(types_1.TokenType.jsxTagStart)) {
            base_1.state.tokens[base_1.state.tokens.length - 1].type = types_1.TokenType.typeParameterStart;
            const oldIsType = (0, index_1.pushTypeContext)(1);
            while (!(0, index_1.match)(types_1.TokenType.greaterThan) && !base_1.state.error) {
                tsParseType();
                (0, index_1.eat)(types_1.TokenType.comma);
            }
            // Process >, but the one after needs to be parsed JSX-style.
            (0, jsx_1.nextJSXTagToken)();
            (0, index_1.popTypeContext)(oldIsType);
        }
    }
    function tsParseHeritageClause() {
        while (!(0, index_1.match)(types_1.TokenType.braceL) && !base_1.state.error) {
            tsParseExpressionWithTypeArguments();
            (0, index_1.eat)(types_1.TokenType.comma);
        }
    }
    function tsParseExpressionWithTypeArguments() {
        // Note: TS uses parseLeftHandSideExpressionOrHigher,
        // then has grammar errors later if it's not an EntityName.
        tsParseEntityName();
        if ((0, index_1.match)(types_1.TokenType.lessThan)) {
            tsParseTypeArguments();
        }
    }
    function tsParseInterfaceDeclaration() {
        (0, lval_1.parseBindingIdentifier)(false);
        tsTryParseTypeParameters();
        if ((0, index_1.eat)(types_1.TokenType._extends)) {
            tsParseHeritageClause();
        }
        tsParseObjectTypeMembers();
    }
    function tsParseTypeAliasDeclaration() {
        (0, lval_1.parseBindingIdentifier)(false);
        tsTryParseTypeParameters();
        (0, util_1.expect)(types_1.TokenType.eq);
        tsParseType();
        (0, util_1.semicolon)();
    }
    function tsParseEnumMember() {
        // Computed property names are grammar errors in an enum, so accept just string literal or identifier.
        if ((0, index_1.match)(types_1.TokenType.string)) {
            (0, expression_1.parseLiteral)();
        }
        else {
            (0, expression_1.parseIdentifier)();
        }
        if ((0, index_1.eat)(types_1.TokenType.eq)) {
            const eqIndex = base_1.state.tokens.length - 1;
            (0, expression_1.parseMaybeAssign)();
            base_1.state.tokens[eqIndex].rhsEndIndex = base_1.state.tokens.length;
        }
    }
    function tsParseEnumDeclaration() {
        (0, lval_1.parseBindingIdentifier)(false);
        (0, util_1.expect)(types_1.TokenType.braceL);
        while (!(0, index_1.eat)(types_1.TokenType.braceR) && !base_1.state.error) {
            tsParseEnumMember();
            (0, index_1.eat)(types_1.TokenType.comma);
        }
    }
    function tsParseModuleBlock() {
        (0, util_1.expect)(types_1.TokenType.braceL);
        (0, statement_1.parseBlockBody)(/* end */ types_1.TokenType.braceR);
    }
    function tsParseModuleOrNamespaceDeclaration() {
        (0, lval_1.parseBindingIdentifier)(false);
        if ((0, index_1.eat)(types_1.TokenType.dot)) {
            tsParseModuleOrNamespaceDeclaration();
        }
        else {
            tsParseModuleBlock();
        }
    }
    function tsParseAmbientExternalModuleDeclaration() {
        if ((0, util_1.isContextual)(keywords_1.ContextualKeyword._global)) {
            (0, expression_1.parseIdentifier)();
        }
        else if ((0, index_1.match)(types_1.TokenType.string)) {
            (0, expression_1.parseExprAtom)();
        }
        else {
            (0, util_1.unexpected)();
        }
        if ((0, index_1.match)(types_1.TokenType.braceL)) {
            tsParseModuleBlock();
        }
        else {
            (0, util_1.semicolon)();
        }
    }
    function tsParseImportEqualsDeclaration() {
        (0, lval_1.parseImportedIdentifier)();
        (0, util_1.expect)(types_1.TokenType.eq);
        tsParseModuleReference();
        (0, util_1.semicolon)();
    }
    function tsIsExternalModuleReference() {
        return (0, util_1.isContextual)(keywords_1.ContextualKeyword._require) && (0, index_1.lookaheadType)() === types_1.TokenType.parenL;
    }
    function tsParseModuleReference() {
        if (tsIsExternalModuleReference()) {
            tsParseExternalModuleReference();
        }
        else {
            tsParseEntityName();
        }
    }
    function tsParseExternalModuleReference() {
        (0, util_1.expectContextual)(keywords_1.ContextualKeyword._require);
        (0, util_1.expect)(types_1.TokenType.parenL);
        if (!(0, index_1.match)(types_1.TokenType.string)) {
            (0, util_1.unexpected)();
        }
        (0, expression_1.parseLiteral)();
        (0, util_1.expect)(types_1.TokenType.parenR);
    }
    // Utilities
    // Returns true if a statement matched.
    function tsTryParseDeclare() {
        if ((0, util_1.isLineTerminator)()) {
            return false;
        }
        switch (base_1.state.type) {
            case types_1.TokenType._function: {
                const oldIsType = (0, index_1.pushTypeContext)(1);
                (0, index_1.next)();
                // We don't need to precisely get the function start here, since it's only used to mark
                // the function as a type if it's bodiless, and it's already a type here.
                const functionStart = base_1.state.start;
                (0, statement_1.parseFunction)(functionStart, /* isStatement */ true);
                (0, index_1.popTypeContext)(oldIsType);
                return true;
            }
            case types_1.TokenType._class: {
                const oldIsType = (0, index_1.pushTypeContext)(1);
                (0, statement_1.parseClass)(/* isStatement */ true, /* optionalId */ false);
                (0, index_1.popTypeContext)(oldIsType);
                return true;
            }
            case types_1.TokenType._const: {
                if ((0, index_1.match)(types_1.TokenType._const) && (0, util_1.isLookaheadContextual)(keywords_1.ContextualKeyword._enum)) {
                    const oldIsType = (0, index_1.pushTypeContext)(1);
                    // `const enum = 0;` not allowed because "enum" is a strict mode reserved word.
                    (0, util_1.expect)(types_1.TokenType._const);
                    (0, util_1.expectContextual)(keywords_1.ContextualKeyword._enum);
                    base_1.state.tokens[base_1.state.tokens.length - 1].type = types_1.TokenType._enum;
                    tsParseEnumDeclaration();
                    (0, index_1.popTypeContext)(oldIsType);
                    return true;
                }
            }
            // falls through
            case types_1.TokenType._var:
            case types_1.TokenType._let: {
                const oldIsType = (0, index_1.pushTypeContext)(1);
                (0, statement_1.parseVarStatement)(base_1.state.type !== types_1.TokenType._var);
                (0, index_1.popTypeContext)(oldIsType);
                return true;
            }
            case types_1.TokenType.name: {
                const oldIsType = (0, index_1.pushTypeContext)(1);
                const contextualKeyword = base_1.state.contextualKeyword;
                let matched = false;
                if (contextualKeyword === keywords_1.ContextualKeyword._global) {
                    tsParseAmbientExternalModuleDeclaration();
                    matched = true;
                }
                else {
                    matched = tsParseDeclaration(contextualKeyword, /* isBeforeToken */ true);
                }
                (0, index_1.popTypeContext)(oldIsType);
                return matched;
            }
            default:
                return false;
        }
    }
    // Note: this won't be called unless the keyword is allowed in `shouldParseExportDeclaration`.
    // Returns true if it matched a declaration.
    function tsTryParseExportDeclaration() {
        return tsParseDeclaration(base_1.state.contextualKeyword, /* isBeforeToken */ true);
    }
    // Returns true if it matched a statement.
    function tsParseExpressionStatement(contextualKeyword) {
        switch (contextualKeyword) {
            case keywords_1.ContextualKeyword._declare: {
                const declareTokenIndex = base_1.state.tokens.length - 1;
                const matched = tsTryParseDeclare();
                if (matched) {
                    base_1.state.tokens[declareTokenIndex].type = types_1.TokenType._declare;
                    return true;
                }
                break;
            }
            case keywords_1.ContextualKeyword._global:
                // `global { }` (with no `declare`) may appear inside an ambient module declaration.
                // Would like to use tsParseAmbientExternalModuleDeclaration here, but already ran past "global".
                if ((0, index_1.match)(types_1.TokenType.braceL)) {
                    tsParseModuleBlock();
                    return true;
                }
                break;
            default:
                return tsParseDeclaration(contextualKeyword, /* isBeforeToken */ false);
        }
        return false;
    }
    /**
     * Common code for parsing a declaration.
     *
     * isBeforeToken indicates that the current parser state is at the contextual
     * keyword (and that it is not yet emitted) rather than reading the token after
     * it. When isBeforeToken is true, we may be preceded by an `export` token and
     * should include that token in a type context we create, e.g. to handle
     * `export interface` or `export type`. (This is a bit of a hack and should be
     * cleaned up at some point.)
     *
     * Returns true if it matched a declaration.
     */
    function tsParseDeclaration(contextualKeyword, isBeforeToken) {
        switch (contextualKeyword) {
            case keywords_1.ContextualKeyword._abstract:
                if (tsCheckLineTerminator(isBeforeToken) && (0, index_1.match)(types_1.TokenType._class)) {
                    base_1.state.tokens[base_1.state.tokens.length - 1].type = types_1.TokenType._abstract;
                    (0, statement_1.parseClass)(/* isStatement */ true, /* optionalId */ false);
                    return true;
                }
                break;
            case keywords_1.ContextualKeyword._enum:
                if (tsCheckLineTerminator(isBeforeToken) && (0, index_1.match)(types_1.TokenType.name)) {
                    base_1.state.tokens[base_1.state.tokens.length - 1].type = types_1.TokenType._enum;
                    tsParseEnumDeclaration();
                    return true;
                }
                break;
            case keywords_1.ContextualKeyword._interface:
                if (tsCheckLineTerminator(isBeforeToken) && (0, index_1.match)(types_1.TokenType.name)) {
                    // `next` is true in "export" and "declare" contexts, so we want to remove that token
                    // as well.
                    const oldIsType = (0, index_1.pushTypeContext)(isBeforeToken ? 2 : 1);
                    tsParseInterfaceDeclaration();
                    (0, index_1.popTypeContext)(oldIsType);
                    return true;
                }
                break;
            case keywords_1.ContextualKeyword._module:
                if (tsCheckLineTerminator(isBeforeToken)) {
                    if ((0, index_1.match)(types_1.TokenType.string)) {
                        const oldIsType = (0, index_1.pushTypeContext)(isBeforeToken ? 2 : 1);
                        tsParseAmbientExternalModuleDeclaration();
                        (0, index_1.popTypeContext)(oldIsType);
                        return true;
                    }
                    else if ((0, index_1.match)(types_1.TokenType.name)) {
                        const oldIsType = (0, index_1.pushTypeContext)(isBeforeToken ? 2 : 1);
                        tsParseModuleOrNamespaceDeclaration();
                        (0, index_1.popTypeContext)(oldIsType);
                        return true;
                    }
                }
                break;
            case keywords_1.ContextualKeyword._namespace:
                if (tsCheckLineTerminator(isBeforeToken) && (0, index_1.match)(types_1.TokenType.name)) {
                    const oldIsType = (0, index_1.pushTypeContext)(isBeforeToken ? 2 : 1);
                    tsParseModuleOrNamespaceDeclaration();
                    (0, index_1.popTypeContext)(oldIsType);
                    return true;
                }
                break;
            case keywords_1.ContextualKeyword._type:
                if (tsCheckLineTerminator(isBeforeToken) && (0, index_1.match)(types_1.TokenType.name)) {
                    const oldIsType = (0, index_1.pushTypeContext)(isBeforeToken ? 2 : 1);
                    tsParseTypeAliasDeclaration();
                    (0, index_1.popTypeContext)(oldIsType);
                    return true;
                }
                break;
            default:
                break;
        }
        return false;
    }
    function tsCheckLineTerminator(isBeforeToken) {
        if (isBeforeToken) {
            // Babel checks hasFollowingLineBreak here and returns false, but this
            // doesn't actually come up, e.g. `export interface` can never be on its own
            // line in valid code.
            (0, index_1.next)();
            return true;
        }
        else {
            return !(0, util_1.isLineTerminator)();
        }
    }
    // Returns true if there was a generic async arrow function.
    function tsTryParseGenericAsyncArrowFunction() {
        const snapshot = base_1.state.snapshot();
        tsParseTypeParameters();
        (0, statement_1.parseFunctionParams)();
        tsTryParseTypeOrTypePredicateAnnotation();
        (0, util_1.expect)(types_1.TokenType.arrow);
        if (base_1.state.error) {
            base_1.state.restoreFromSnapshot(snapshot);
            return false;
        }
        (0, expression_1.parseFunctionBody)(true);
        return true;
    }
    /**
     * If necessary, hack the tokenizer state so that this bitshift was actually a
     * less-than token, then keep parsing. This should only be used in situations
     * where we restore from snapshot on error (which reverts this change) or
     * where bitshift would be illegal anyway (e.g. in a class "extends" clause).
     *
     * This hack is useful to handle situations like foo<<T>() => void>() where
     * there can legitimately be two open-angle-brackets in a row in TS.
     */
    function tsParseTypeArgumentsWithPossibleBitshift() {
        if (base_1.state.type === types_1.TokenType.bitShiftL) {
            base_1.state.pos -= 1;
            (0, index_1.finishToken)(types_1.TokenType.lessThan);
        }
        tsParseTypeArguments();
    }
    function tsParseTypeArguments() {
        const oldIsType = (0, index_1.pushTypeContext)(0);
        (0, util_1.expect)(types_1.TokenType.lessThan);
        while (!(0, index_1.match)(types_1.TokenType.greaterThan) && !base_1.state.error) {
            tsParseType();
            (0, index_1.eat)(types_1.TokenType.comma);
        }
        if (!oldIsType) {
            // If the type arguments are present in an expression context, e.g.
            // f<number>(), then the > sign should be tokenized as a non-type token.
            // In particular, f(a < b, c >= d) should parse the >= as a single token,
            // resulting in a syntax error and fallback to the non-type-args
            // interpretation. In the success case, even though the > is tokenized as a
            // non-type token, it still must be marked as a type token so that it is
            // erased.
            (0, index_1.popTypeContext)(oldIsType);
            (0, index_1.rescan_gt)();
            (0, util_1.expect)(types_1.TokenType.greaterThan);
            base_1.state.tokens[base_1.state.tokens.length - 1].isType = true;
        }
        else {
            (0, util_1.expect)(types_1.TokenType.greaterThan);
            (0, index_1.popTypeContext)(oldIsType);
        }
    }
    function tsIsDeclarationStart() {
        if ((0, index_1.match)(types_1.TokenType.name)) {
            switch (base_1.state.contextualKeyword) {
                case keywords_1.ContextualKeyword._abstract:
                case keywords_1.ContextualKeyword._declare:
                case keywords_1.ContextualKeyword._enum:
                case keywords_1.ContextualKeyword._interface:
                case keywords_1.ContextualKeyword._module:
                case keywords_1.ContextualKeyword._namespace:
                case keywords_1.ContextualKeyword._type:
                    return true;
                default:
                    break;
            }
        }
        return false;
    }
    // ======================================================
    // OVERRIDES
    // ======================================================
    function tsParseFunctionBodyAndFinish(functionStart, funcContextId) {
        // For arrow functions, `parseArrow` handles the return type itself.
        if ((0, index_1.match)(types_1.TokenType.colon)) {
            tsParseTypeOrTypePredicateAnnotation(types_1.TokenType.colon);
        }
        // The original code checked the node type to make sure this function type allows a missing
        // body, but we skip that to avoid sending around the node type. We instead just use the
        // allowExpressionBody boolean to make sure it's not an arrow function.
        if (!(0, index_1.match)(types_1.TokenType.braceL) && (0, util_1.isLineTerminator)()) {
            // Retroactively mark the function declaration as a type.
            let i = base_1.state.tokens.length - 1;
            while (i >= 0 &&
                (base_1.state.tokens[i].start >= functionStart ||
                    base_1.state.tokens[i].type === types_1.TokenType._default ||
                    base_1.state.tokens[i].type === types_1.TokenType._export)) {
                base_1.state.tokens[i].isType = true;
                i--;
            }
            return;
        }
        (0, expression_1.parseFunctionBody)(false, funcContextId);
    }
    function tsParseSubscript(startTokenIndex, noCalls, stopState) {
        if (!(0, util_1.hasPrecedingLineBreak)() && (0, index_1.eat)(types_1.TokenType.bang)) {
            base_1.state.tokens[base_1.state.tokens.length - 1].type = types_1.TokenType.nonNullAssertion;
            return;
        }
        if ((0, index_1.match)(types_1.TokenType.lessThan) || (0, index_1.match)(types_1.TokenType.bitShiftL)) {
            // There are number of things we are going to "maybe" parse, like type arguments on
            // tagged template expressions. If any of them fail, walk it back and continue.
            const snapshot = base_1.state.snapshot();
            if (!noCalls && (0, expression_1.atPossibleAsync)()) {
                // Almost certainly this is a generic async function `async <T>() => ...
                // But it might be a call with a type argument `async<T>();`
                const asyncArrowFn = tsTryParseGenericAsyncArrowFunction();
                if (asyncArrowFn) {
                    return;
                }
            }
            tsParseTypeArgumentsWithPossibleBitshift();
            if (!noCalls && (0, index_1.eat)(types_1.TokenType.parenL)) {
                // With f<T>(), the subscriptStartIndex marker is on the ( token.
                base_1.state.tokens[base_1.state.tokens.length - 1].subscriptStartIndex = startTokenIndex;
                (0, expression_1.parseCallExpressionArguments)();
            }
            else if ((0, index_1.match)(types_1.TokenType.backQuote)) {
                // Tagged template with a type argument.
                (0, expression_1.parseTemplate)();
            }
            else if (
            // The remaining possible case is an instantiation expression, e.g.
            // Array<number> . Check for a few cases that would disqualify it and
            // cause us to bail out.
            // a<b>>c is not (a<b>)>c, but a<(b>>c)
            base_1.state.type === types_1.TokenType.greaterThan ||
                // a<b>c is (a<b)>c
                (base_1.state.type !== types_1.TokenType.parenL &&
                    Boolean(base_1.state.type & types_1.TokenType.IS_EXPRESSION_START) &&
                    !(0, util_1.hasPrecedingLineBreak)())) {
                // Bail out. We have something like a<b>c, which is not an expression with
                // type arguments but an (a < b) > c comparison.
                (0, util_1.unexpected)();
            }
            if (base_1.state.error) {
                base_1.state.restoreFromSnapshot(snapshot);
            }
            else {
                return;
            }
        }
        else if (!noCalls && (0, index_1.match)(types_1.TokenType.questionDot) && (0, index_1.lookaheadType)() === types_1.TokenType.lessThan) {
            // If we see f?.<, then this must be an optional call with a type argument.
            (0, index_1.next)();
            base_1.state.tokens[startTokenIndex].isOptionalChainStart = true;
            // With f?.<T>(), the subscriptStartIndex marker is on the ?. token.
            base_1.state.tokens[base_1.state.tokens.length - 1].subscriptStartIndex = startTokenIndex;
            tsParseTypeArguments();
            (0, util_1.expect)(types_1.TokenType.parenL);
            (0, expression_1.parseCallExpressionArguments)();
        }
        (0, expression_1.baseParseSubscript)(startTokenIndex, noCalls, stopState);
    }
    function tsTryParseExport() {
        if ((0, index_1.eat)(types_1.TokenType._import)) {
            // One of these cases:
            // export import A = B;
            // export import type A = require("A");
            if ((0, util_1.isContextual)(keywords_1.ContextualKeyword._type) && (0, index_1.lookaheadType)() !== types_1.TokenType.eq) {
                // Eat a `type` token, unless it's actually an identifier name.
                (0, util_1.expectContextual)(keywords_1.ContextualKeyword._type);
            }
            tsParseImportEqualsDeclaration();
            return true;
        }
        else if ((0, index_1.eat)(types_1.TokenType.eq)) {
            // `export = x;`
            (0, expression_1.parseExpression)();
            (0, util_1.semicolon)();
            return true;
        }
        else if ((0, util_1.eatContextual)(keywords_1.ContextualKeyword._as)) {
            // `export as namespace A;`
            // See `parseNamespaceExportDeclaration` in TypeScript's own parser
            (0, util_1.expectContextual)(keywords_1.ContextualKeyword._namespace);
            (0, expression_1.parseIdentifier)();
            (0, util_1.semicolon)();
            return true;
        }
        else {
            if ((0, util_1.isContextual)(keywords_1.ContextualKeyword._type)) {
                const nextType = (0, index_1.lookaheadType)();
                // export type {foo} from 'a';
                // export type * from 'a';'
                // export type * as ns from 'a';'
                if (nextType === types_1.TokenType.braceL || nextType === types_1.TokenType.star) {
                    (0, index_1.next)();
                }
            }
            return false;
        }
    }
    /**
     * Parse a TS import specifier, which may be prefixed with "type" and may be of
     * the form `foo as bar`.
     *
     * The number of identifier-like tokens we see happens to be enough to uniquely
     * identify the form, so simply count the number of identifiers rather than
     * matching the words `type` or `as`. This is particularly important because
     * `type` and `as` could each actually be plain identifiers rather than
     * keywords.
     */
    function tsParseImportSpecifier() {
        (0, expression_1.parseIdentifier)();
        if ((0, index_1.match)(types_1.TokenType.comma) || (0, index_1.match)(types_1.TokenType.braceR)) {
            // import {foo}
            base_1.state.tokens[base_1.state.tokens.length - 1].identifierRole = index_1.IdentifierRole.ImportDeclaration;
            return;
        }
        (0, expression_1.parseIdentifier)();
        if ((0, index_1.match)(types_1.TokenType.comma) || (0, index_1.match)(types_1.TokenType.braceR)) {
            // import {type foo}
            base_1.state.tokens[base_1.state.tokens.length - 1].identifierRole = index_1.IdentifierRole.ImportDeclaration;
            base_1.state.tokens[base_1.state.tokens.length - 2].isType = true;
            base_1.state.tokens[base_1.state.tokens.length - 1].isType = true;
            return;
        }
        (0, expression_1.parseIdentifier)();
        if ((0, index_1.match)(types_1.TokenType.comma) || (0, index_1.match)(types_1.TokenType.braceR)) {
            // import {foo as bar}
            base_1.state.tokens[base_1.state.tokens.length - 3].identifierRole = index_1.IdentifierRole.ImportAccess;
            base_1.state.tokens[base_1.state.tokens.length - 1].identifierRole = index_1.IdentifierRole.ImportDeclaration;
            return;
        }
        (0, expression_1.parseIdentifier)();
        // import {type foo as bar}
        base_1.state.tokens[base_1.state.tokens.length - 3].identifierRole = index_1.IdentifierRole.ImportAccess;
        base_1.state.tokens[base_1.state.tokens.length - 1].identifierRole = index_1.IdentifierRole.ImportDeclaration;
        base_1.state.tokens[base_1.state.tokens.length - 4].isType = true;
        base_1.state.tokens[base_1.state.tokens.length - 3].isType = true;
        base_1.state.tokens[base_1.state.tokens.length - 2].isType = true;
        base_1.state.tokens[base_1.state.tokens.length - 1].isType = true;
    }
    /**
     * Just like named import specifiers, export specifiers can have from 1 to 4
     * tokens, inclusive, and the number of tokens determines the role of each token.
     */
    function tsParseExportSpecifier() {
        (0, expression_1.parseIdentifier)();
        if ((0, index_1.match)(types_1.TokenType.comma) || (0, index_1.match)(types_1.TokenType.braceR)) {
            // export {foo}
            base_1.state.tokens[base_1.state.tokens.length - 1].identifierRole = index_1.IdentifierRole.ExportAccess;
            return;
        }
        (0, expression_1.parseIdentifier)();
        if ((0, index_1.match)(types_1.TokenType.comma) || (0, index_1.match)(types_1.TokenType.braceR)) {
            // export {type foo}
            base_1.state.tokens[base_1.state.tokens.length - 1].identifierRole = index_1.IdentifierRole.ExportAccess;
            base_1.state.tokens[base_1.state.tokens.length - 2].isType = true;
            base_1.state.tokens[base_1.state.tokens.length - 1].isType = true;
            return;
        }
        (0, expression_1.parseIdentifier)();
        if ((0, index_1.match)(types_1.TokenType.comma) || (0, index_1.match)(types_1.TokenType.braceR)) {
            // export {foo as bar}
            base_1.state.tokens[base_1.state.tokens.length - 3].identifierRole = index_1.IdentifierRole.ExportAccess;
            return;
        }
        (0, expression_1.parseIdentifier)();
        // export {type foo as bar}
        base_1.state.tokens[base_1.state.tokens.length - 3].identifierRole = index_1.IdentifierRole.ExportAccess;
        base_1.state.tokens[base_1.state.tokens.length - 4].isType = true;
        base_1.state.tokens[base_1.state.tokens.length - 3].isType = true;
        base_1.state.tokens[base_1.state.tokens.length - 2].isType = true;
        base_1.state.tokens[base_1.state.tokens.length - 1].isType = true;
    }
    function tsTryParseExportDefaultExpression() {
        if ((0, util_1.isContextual)(keywords_1.ContextualKeyword._abstract) && (0, index_1.lookaheadType)() === types_1.TokenType._class) {
            base_1.state.type = types_1.TokenType._abstract;
            (0, index_1.next)(); // Skip "abstract"
            (0, statement_1.parseClass)(true, true);
            return true;
        }
        if ((0, util_1.isContextual)(keywords_1.ContextualKeyword._interface)) {
            // Make sure "export default" are considered type tokens so the whole thing is removed.
            const oldIsType = (0, index_1.pushTypeContext)(2);
            tsParseDeclaration(keywords_1.ContextualKeyword._interface, true);
            (0, index_1.popTypeContext)(oldIsType);
            return true;
        }
        return false;
    }
    function tsTryParseStatementContent() {
        if (base_1.state.type === types_1.TokenType._const) {
            const ahead = (0, index_1.lookaheadTypeAndKeyword)();
            if (ahead.type === types_1.TokenType.name && ahead.contextualKeyword === keywords_1.ContextualKeyword._enum) {
                (0, util_1.expect)(types_1.TokenType._const);
                (0, util_1.expectContextual)(keywords_1.ContextualKeyword._enum);
                base_1.state.tokens[base_1.state.tokens.length - 1].type = types_1.TokenType._enum;
                tsParseEnumDeclaration();
                return true;
            }
        }
        return false;
    }
    function tsTryParseClassMemberWithIsStatic(isStatic) {
        const memberStartIndexAfterStatic = base_1.state.tokens.length;
        tsParseModifiers([
            keywords_1.ContextualKeyword._abstract,
            keywords_1.ContextualKeyword._readonly,
            keywords_1.ContextualKeyword._declare,
            keywords_1.ContextualKeyword._static,
            keywords_1.ContextualKeyword._override,
        ]);
        const modifiersEndIndex = base_1.state.tokens.length;
        const found = tsTryParseIndexSignature();
        if (found) {
            // Index signatures are type declarations, so set the modifier tokens as
            // type tokens. Most tokens could be assumed to be type tokens, but `static`
            // is ambiguous unless we set it explicitly here.
            const memberStartIndex = isStatic
                ? memberStartIndexAfterStatic - 1
                : memberStartIndexAfterStatic;
            for (let i = memberStartIndex; i < modifiersEndIndex; i++) {
                base_1.state.tokens[i].isType = true;
            }
            return true;
        }
        return false;
    }
    // Note: The reason we do this in `parseIdentifierStatement` and not `parseStatement`
    // is that e.g. `type()` is valid JS, so we must try parsing that first.
    // If it's really a type, we will parse `type` as the statement, and can correct it here
    // by parsing the rest.
    function tsParseIdentifierStatement(contextualKeyword) {
        const matched = tsParseExpressionStatement(contextualKeyword);
        if (!matched) {
            (0, util_1.semicolon)();
        }
    }
    function tsParseExportDeclaration() {
        // "export declare" is equivalent to just "export".
        const isDeclare = (0, util_1.eatContextual)(keywords_1.ContextualKeyword._declare);
        if (isDeclare) {
            base_1.state.tokens[base_1.state.tokens.length - 1].type = types_1.TokenType._declare;
        }
        let matchedDeclaration = false;
        if ((0, index_1.match)(types_1.TokenType.name)) {
            if (isDeclare) {
                const oldIsType = (0, index_1.pushTypeContext)(2);
                matchedDeclaration = tsTryParseExportDeclaration();
                (0, index_1.popTypeContext)(oldIsType);
            }
            else {
                matchedDeclaration = tsTryParseExportDeclaration();
            }
        }
        if (!matchedDeclaration) {
            if (isDeclare) {
                const oldIsType = (0, index_1.pushTypeContext)(2);
                (0, statement_1.parseStatement)(true);
                (0, index_1.popTypeContext)(oldIsType);
            }
            else {
                (0, statement_1.parseStatement)(true);
            }
        }
    }
    function tsAfterParseClassSuper(hasSuper) {
        if (hasSuper && ((0, index_1.match)(types_1.TokenType.lessThan) || (0, index_1.match)(types_1.TokenType.bitShiftL))) {
            tsParseTypeArgumentsWithPossibleBitshift();
        }
        if ((0, util_1.eatContextual)(keywords_1.ContextualKeyword._implements)) {
            base_1.state.tokens[base_1.state.tokens.length - 1].type = types_1.TokenType._implements;
            const oldIsType = (0, index_1.pushTypeContext)(1);
            tsParseHeritageClause();
            (0, index_1.popTypeContext)(oldIsType);
        }
    }
    function tsStartParseObjPropValue() {
        tsTryParseTypeParameters();
    }
    function tsStartParseFunctionParams() {
        tsTryParseTypeParameters();
    }
    // `let x: number;`
    function tsAfterParseVarHead() {
        const oldIsType = (0, index_1.pushTypeContext)(0);
        if (!(0, util_1.hasPrecedingLineBreak)()) {
            (0, index_1.eat)(types_1.TokenType.bang);
        }
        tsTryParseTypeAnnotation();
        (0, index_1.popTypeContext)(oldIsType);
    }
    // parse the return type of an async arrow function - let foo = (async (): number => {});
    function tsStartParseAsyncArrowFromCallExpression() {
        if ((0, index_1.match)(types_1.TokenType.colon)) {
            tsParseTypeAnnotation();
        }
    }
    // Returns true if the expression was an arrow function.
    function tsParseMaybeAssign(noIn, isWithinParens) {
        // Note: When the JSX plugin is on, type assertions (`<T> x`) aren't valid syntax.
        if (base_1.isJSXEnabled) {
            return tsParseMaybeAssignWithJSX(noIn, isWithinParens);
        }
        else {
            return tsParseMaybeAssignWithoutJSX(noIn, isWithinParens);
        }
    }
    function tsParseMaybeAssignWithJSX(noIn, isWithinParens) {
        if (!(0, index_1.match)(types_1.TokenType.lessThan)) {
            return (0, expression_1.baseParseMaybeAssign)(noIn, isWithinParens);
        }
        // Prefer to parse JSX if possible. But may be an arrow fn.
        const snapshot = base_1.state.snapshot();
        let wasArrow = (0, expression_1.baseParseMaybeAssign)(noIn, isWithinParens);
        if (base_1.state.error) {
            base_1.state.restoreFromSnapshot(snapshot);
        }
        else {
            return wasArrow;
        }
        // Otherwise, try as type-parameterized arrow function.
        base_1.state.type = types_1.TokenType.typeParameterStart;
        // This is similar to TypeScript's `tryParseParenthesizedArrowFunctionExpression`.
        tsParseTypeParameters();
        wasArrow = (0, expression_1.baseParseMaybeAssign)(noIn, isWithinParens);
        if (!wasArrow) {
            (0, util_1.unexpected)();
        }
        return wasArrow;
    }
    function tsParseMaybeAssignWithoutJSX(noIn, isWithinParens) {
        if (!(0, index_1.match)(types_1.TokenType.lessThan)) {
            return (0, expression_1.baseParseMaybeAssign)(noIn, isWithinParens);
        }
        const snapshot = base_1.state.snapshot();
        // This is similar to TypeScript's `tryParseParenthesizedArrowFunctionExpression`.
        tsParseTypeParameters();
        const wasArrow = (0, expression_1.baseParseMaybeAssign)(noIn, isWithinParens);
        if (!wasArrow) {
            (0, util_1.unexpected)();
        }
        if (base_1.state.error) {
            base_1.state.restoreFromSnapshot(snapshot);
        }
        else {
            return wasArrow;
        }
        // Try parsing a type cast instead of an arrow function.
        // This will start with a type assertion (via parseMaybeUnary).
        // But don't directly call `tsParseTypeAssertion` because we want to handle any binary after it.
        return (0, expression_1.baseParseMaybeAssign)(noIn, isWithinParens);
    }
    function tsParseArrow() {
        if ((0, index_1.match)(types_1.TokenType.colon)) {
            // This is different from how the TS parser does it.
            // TS uses lookahead. Babylon parses it as a parenthesized expression and converts.
            const snapshot = base_1.state.snapshot();
            tsParseTypeOrTypePredicateAnnotation(types_1.TokenType.colon);
            if ((0, util_1.canInsertSemicolon)())
                (0, util_1.unexpected)();
            if (!(0, index_1.match)(types_1.TokenType.arrow))
                (0, util_1.unexpected)();
            if (base_1.state.error) {
                base_1.state.restoreFromSnapshot(snapshot);
            }
        }
        return (0, index_1.eat)(types_1.TokenType.arrow);
    }
    // Allow type annotations inside of a parameter list.
    function tsParseAssignableListItemTypes() {
        const oldIsType = (0, index_1.pushTypeContext)(0);
        (0, index_1.eat)(types_1.TokenType.question);
        tsTryParseTypeAnnotation();
        (0, index_1.popTypeContext)(oldIsType);
    }
    function tsParseMaybeDecoratorArguments() {
        if ((0, index_1.match)(types_1.TokenType.lessThan) || (0, index_1.match)(types_1.TokenType.bitShiftL)) {
            tsParseTypeArgumentsWithPossibleBitshift();
        }
        (0, statement_1.baseParseMaybeDecoratorArguments)();
    }
}
